import React from 'react'

import WhyChooseSection from '../Components/hospital/WhyChooseSection'
import ProductOverview from '../Components/data/ProductOverview'
import WhatItDoes from '../Components/data/WhatItDoes'
import WorkWaysSection from '../Components/data/WorkWaysSection'
import GetStartedSection from '../Components/data/GetStartedSection'
import { Helmet } from 'react-helmet-async';

function DataExtraction() {
    return (
        <div>
            <Helmet>
    <title>
        Data Extraction & Analytics Services | Mobikode
    </title>

    <meta
        name="description"
        content="Mobikode provides data extraction and analytics solutions that help businesses collect, process, analyze, and transform data into meaningful insights for better decisions and business outcomes."
    />

    <meta
        name="keywords"
        content="Data Extraction Services, Data Extraction Solutions, Data Analytics Services, Data Analytics Solutions, Data Extraction Company, Enterprise Data Extraction, Data Processing Services, Data Analysis Services, Business Data Analytics, Data Insights, Data Integration Services, Data Transformation Services, Industrial Data Extraction, Automated Data Extraction, Data Analytics Consulting"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/data-extraction"
    />

    <meta
        property="og:title"
        content="Data Extraction & Analytics Services | Mobikode"
    />

    <meta
        property="og:description"
        content="Turn extracted data into actionable insights with Mobikode's data extraction and analytics solutions designed to support smarter decisions, improved visibility, and better business outcomes."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/data-extraction"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/data/bg1.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="Data Extraction & Analytics Services | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Explore Mobikode's data extraction and analytics capabilities to collect valuable data, uncover insights, and support data-driven business decisions."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/data/bg1.png"
    />
</Helmet>
            <section className="relative w-full h-[500px] lg:h-[630px] flex items-center bg-[#000814] overflow-hidden py-12 md:py-0">
                <div className="absolute inset-0 z-0">
                    <img
                        src="/assets/data/bg1.png"
                        alt="Abstract 3D Background"
                        className="w-full h-full object-cover"
                    />
                    <div
                        style={{ background: "linear-gradient(86.84deg, #000000 20%, rgba(0, 0, 0, 0) 79%)" }}
                        className="hidden md:block absolute inset-0"
                    ></div>
                    <div
                        style={{ background: "linear-gradient(0deg, #000000 40%, rgba(0, 0, 0, 0.3) 100%)" }}
                        className="block md:hidden absolute inset-0"
                    ></div>
                </div>
                <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px] flex flex-col items-start justify-center h-full">
                    <div className="w-full max-w-[500px] md:max-w-[700px] lg:max-w-[900px] mt-auto md:mt-0">
                        <h1 className="text-white font-[600] text-[28px] sm:text-[36px] md:text-[50px] lg:text-[60px] font-sora leading-[1.2] lg:leading-[1.1] mb-[12px] lg:mb-[22px] drop-shadow-xl tracking-wide text-left">
                            Data Extraction & Analytics
                        </h1>
                        {/* <p className="text-[#FFFFFF] max-w-[800px] w-full text-[14px] sm:text-[16px] md:text-[18px] leading-[20px] md:leading-[22px] lg:leading-[24px] font-graphik font-light tracking-wider text-left opacity-90 lg:opacity-100">
                            Turn raw plant data into decisions — automatically.
                        </p> */}
                    </div>
                </div>
            </section>
            <ProductOverview />
            <WhatItDoes />
            <WorkWaysSection />
            <GetStartedSection />
        </div>
    )
}

export default DataExtraction
